'use client';
import React from 'react';
import { Shield } from 'lucide-react';

export default function SafetyReminderBanner() {
  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-sm">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Shield size={15} className="text-white/70" />
        </div>
        <div className="flex-1 space-y-2">
          <h4 className="text-sm font-semibold text-white">Member Safety Reminder</h4>
          <p className="text-xs text-white/70 leading-relaxed">
            JSN does not conduct background checks on members. Exercise caution and good judgment when meeting anyone online. Report suspicious profiles immediately. Never send money to someone you have not met in person.
          </p>
          <div className="flex flex-wrap gap-3 pt-1 text-xs text-white/50">
            <a href="/safety" className="hover:text-white/80 transition-colors underline underline-offset-2">Community Guidelines</a>
            <a href="/safety" className="hover:text-white/80 transition-colors underline underline-offset-2">Privacy Policy</a>
            <a href="/safety" className="hover:text-white/80 transition-colors underline underline-offset-2">Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  );
}
